import '@aws-amplify/ui-react/styles.css'
import 'proxy-polyfill' // IE11 needs a polyfill for Proxy support

import React, { Component, Suspense, lazy } from 'react'

import PropTypes from 'prop-types'

import PoziAuthAWS from 'aws/auth'
import Loading from 'utils/Loading'
// import MyCustomGreetings from './Greetings'

// Trick to use lazy loading for named imports (not currently supported by React)
// Inpired by: https://github.com/facebook/react/issues/14603#issuecomment-736878172
const lazily = (loader) => new Proxy({}, {
  get: (target, componentName) =>
    lazy(async () => ({ default: (await loader())[componentName] }))
})

// Lazy load some components
const { Authenticator } = lazily(() => import('@aws-amplify/ui-react'))

/**
 * @api {NA} AuthAWSReact().render Render component
 * @apiDescription Component to manage logins via AWS cognito.
 * @apiGroup Auth
 * @apiName AuthAWSReactComponent
 * @apiHeader (Amplify) {Component} Authenticator React component to manage cognito auth.
 * @apiHeader (Amplify) {Link} AuthGuide https://aws.github.io/aws-amplify/media/authentication_guide
 * @apiHeader (Amplify) {Link} StorageGuide https://aws.github.io/aws-amplify/media/storage_guide
 */
export default class AuthAWSReact extends Component {
  render () {
    // Hmm, can't get themes to work, see: https://aws-amplify.github.io/docs/js/authentication
    const MyTheme = {
      FormSection: { minWidth: '300px' }
    }

    return (
      <Suspense fallback={<Loading />}>
        <Authenticator theme={MyTheme} hideSignUp>
          {(result) => {
            // Hack to refresh page after succesful login.
            console.debug('AuthAWSReact - login successful.', { ...result })

            // Update authentication status to signed in
            window.setTimeout(() => PoziAuthAWS().stateChange('signedIn'), 100)

            return null
          }}
        </Authenticator>
      </Suspense>
    )
  }
}

AuthAWSReact.propTypes = {
  hide: PropTypes.bool
}
